export const CONNECT_CHANNEL_SUCCESS = 'onboard/signup/CONNECT_CHANNEL_SUCCESS'
export const CONNECT_CHANNEL_FAILURE = 'onboard/signup/CONNECT_CHANNEL_FAILURE'
